// 01. Function to clear alt attributes from images in the Rebuy Smart Cart
// This function selects all images within a specific element and removes their alt attributes
function clearAltAttributes() {
  const images = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations img",
  );
  images.forEach(function (img) {
    img.removeAttribute("alt");
  });
}

// Function to set aria-hidden attributes to true for image links in the Rebuy Smart Cart
// This function selects all image links within a specific element and sets aria-hidden=true
function updateAriaHiddenAttributes() {
  const imageLinks = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations .rebuy-product-image",
  );
  imageLinks.forEach((link) => {
    link.ariaHidden = "true";
  });
}

// Function to set up a MutationObserver on '.rebuy-cart__flyout-recommendations'
// This function sets up a MutationObserver to watch for changes in the DOM within a specific element
function setupImageAltAttributeObserver() {
  const targetNode = document.querySelector(
    ".rebuy-cart__flyout-recommendations",
  );

  if (targetNode) {
    // Set up the observer
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          clearAltAttributes();
          updateAriaHiddenAttributes();
        }
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  } else {
    // Node not found, check again after a delay
    setTimeout(setupImageAltAttributeObserver, 500); // Adjust the delay as needed
  }
}
// This function handles Rebuy events and re-initializes the observer setup
function handleRebuyEvents() {
  clearAltAttributes();
  updateAriaHiddenAttributes();
  setupImageAltAttributeObserver();
}

// Event listeners for Rebuy events
// These event listeners trigger the handleRebuyEvents function when the specified Rebuy events occur
document.addEventListener("rebuy:smartcart.ready", handleRebuyEvents);
document.addEventListener("rebuy:cart.change", handleRebuyEvents);

// Initial call to start the observer setup process
// This function call initiates the setup of the MutationObserver
setupImageAltAttributeObserver();
//
//
// End of 01

// 02. Function to modify route badge button in the Rebuy Smart Cart
// This function modifies the behavior of a specific button in the smart cart

//
//
// End of 02

// 03. Function to add labels to variant selectors in the Rebuy Smart Cart
// This function adds labels to variant selectors in the product options
function rebuyCartAddLabelsToProductOptions() {
  var productOptions = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations .rebuy-product-options",
  );

  productOptions.forEach(function (option, index) {
    if (option.querySelector("label.product-variant-selector-label") === null) {
      var label = document.createElement("label");
      label.textContent = "Select product variant";
      label.classList.add("product-variant-selector-label");

      var select = option.querySelector("select");
      if (select) {
        if (!select.id) {
          select.id = "product-variant-select-" + index;
        }
        label.setAttribute("for", select.id);
      }

      option.insertBefore(label, option.firstChild);
    }
  });
}

// Set up the MutationObserver to listen for changes specific to rebuyCartAddLabelsToProductOptions
// This function sets up a MutationObserver to watch for changes in the DOM specific to the rebuyCartAddLabelsToProductOptions function
function setupMutationObserverForLabels() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        rebuyCartAddLabelsToProductOptions(); // Added this function call
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Call rebuyCartAddLabelsToProductOptions on page load
// This function call adds labels to variant selectors when the page loads
document.addEventListener("DOMContentLoaded", () => {
  rebuyCartAddLabelsToProductOptions();
});

// Call setupMutationObserverForLabels to observe changes specifically for rebuyCartAddLabelsToProductOptions
// This function call sets up a MutationObserver to watch for changes in the DOM specific to the rebuyCartAddLabelsToProductOptions function
setupMutationObserverForLabels();
//
//
// End of 03

// 04. Function to set focus to the nearest select element in '.rebuy-product-block' in the Rebuy Smart Cart
// This function sets focus to the nearest select element in the '.rebuy-product-block' element
function rebuyCartFocusNearestSelect(event) {
  var button = event.target.closest(
    ".rebuy-product-block .rebuy-product-actions button",
  );
  if (button) {
    var productBlock = button.closest(".rebuy-product-block");
    if (productBlock) {
      // Adding a slight delay to allow for the select element to be ready
      setTimeout(function () {
        var selectElement = productBlock.querySelector(
          ".rebuy-product-options select",
        );
        if (selectElement) {
          selectElement.focus();
        }
      }, 100); // Delay of 100 milliseconds; adjust as necessary
    }
  }
}

// Event listener for the click event
// This event listener triggers the rebuyCartFocusNearestSelect function when a click event occurs
document.body.addEventListener("click", rebuyCartFocusNearestSelect);
//
//
// End of 04

// 05. Function to trap focus within the Route modal widget in the Rebuy Smart Cart
// This function traps focus within the modal
function rebuyCartTrapFocusRouteModal() {
  const modalElement = document.getElementById("rm-modal-container");
  if (!modalElement) return; // Check if the modal exists

  // Get all focusable elements within the modal
  const rebuyCartRouteModalFocusableElements = modalElement.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])',
  );

  const rebuyCartRouteModalFirstElement =
    rebuyCartRouteModalFocusableElements[0];
  const rebuyCartRouteModalLastElement =
    rebuyCartRouteModalFocusableElements[
      rebuyCartRouteModalFocusableElements.length - 1
    ];

  modalElement.addEventListener("keydown", function (event) {
    if (event.key === "Tab") {
      if (event.shiftKey) {
        // If Shift+Tab is pressed, move focus to the last focusable element
        if (document.activeElement === rebuyCartRouteModalFirstElement) {
          event.preventDefault();
          rebuyCartRouteModalLastElement.focus();
        }
      } else {
        // If Tab is pressed, move focus to the first focusable element
        if (document.activeElement === rebuyCartRouteModalLastElement) {
          event.preventDefault();
          rebuyCartRouteModalFirstElement.focus();
        }
      }
    }
  });

  // Add the aria-modal attribute to indicate a modal dialog
  modalElement.setAttribute("aria-modal", "true");
  // Add the aria-labelledby attribute with the appropriate label ID
  modalElement.setAttribute("aria-labelledby", "rebuyCartRouteModalTitle");
  // Set the tabindex attribute to -1 to allow programmatic focus
  modalElement.setAttribute("tabindex", "-1");
}

// Function to check if the modal is open and set up focus trapping
// This function checks if the modal is open and sets up focus trapping
function rebuyCartCheckModalOpenRouteModal() {
  const routeModal = document.querySelector(".route-modal.rm-open");
  if (routeModal) {
    // If route-modal has class rm-open, call the focus trapping function
    rebuyCartTrapFocusRouteModal();

    // Add an ID to the route-modal__title element
    const routeModalTitleElement = routeModal.querySelector(
      ".route-modal__title",
    );
    if (routeModalTitleElement) {
      routeModalTitleElement.id = "rebuyCartRouteModalTitle";
    }
  }
}

// Set up a MutationObserver to watch for changes in the DOM
// This function sets up a MutationObserver to watch for changes in the DOM
const rebuyCartObserverRouteModal = new MutationObserver(
  rebuyCartCheckModalOpenRouteModal,
);
rebuyCartObserverRouteModal.observe(document.body, {
  childList: true,
  subtree: true,
});

// Call the checkModalOpen function on initial load
// This function call checks if the modal is open and sets up focus trapping on initial load
rebuyCartCheckModalOpenRouteModal();
//
//
// End of 05

// Set up a MutationObserver to watch for changes in the cart in flyout apps section
function setupRebuyCartRouteNoticeObserver() {
  const routeModalOpener = document.querySelector('.pw-route-protection .default-text');
  if (routeModalOpener) {
    const targetNode = document.querySelector('.rebuy-cart__flyout-apps');
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          rebuyCartRouteNoticeUpdate();
        }
      }
    });
    observer.observe(targetNode, { childList: true, subtree: true });
  }
}

// Function to update route notice attributes and add proper events to the div that should open the modal
function rebuyCartRouteNoticeUpdate() {
  const routeModalOpener = document.querySelector('.pw-route-protection .default-text');
  if (routeModalOpener) {
    const detaulModalOpener = routeModalOpener.querySelector('.pw-learn-more');
    routeModalOpener.setAttribute('tabindex', '0');
    routeModalOpener.setAttribute('role', 'button');
    routeModalOpener.setAttribute('aria-haspopup', 'dialog');
    routeModalOpener.setAttribute('aria-label', 'Learn More about Package Protection');

    routeModalOpener.addEventListener('click', function(event) {
      detaulModalOpener.click();
    });

    routeModalOpener.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === '' || event.code  === 'Space') {
        detaulModalOpener.click();
      }
    });
  }
}

document.addEventListener("rebuy:cart.change", setupRebuyCartRouteNoticeObserver);